import React from 'react'
import { HamburgerIcon } from 'src/assets/images'
import { useHamburger } from './HamburgerContext'
import './HamburgerButton.scss'

export const HamburgerButton = () => {
  const { opened, toggleOpen } = useHamburger()
  return (
    <button className="hamburger-button" onClick={toggleOpen}>
      <img
        src={HamburgerIcon}
        alt="hamburger-icon"
        className={`hamburger-button__icon ${opened && 'open'}`}
      />
    </button>
  )
}
